<template>
  <div class="total-wrapper">
    <div v-if="searched">
      <the-search-bar v-on:gotHouseData="setHouseData"></the-search-bar>
      <div id="map-wrapper" class="col">
        <div class="row h-100"  v-if="!noHouseData">
          <the-map v-bind:houseData="houseData" v-on:unit-data-requested="unitAddresses = $event"></the-map>
          <div class="col-6" id="right-side" v-on:scroll="loadMoreCards" ref="rightSide">
            <div v-if="!getSecretAccessKey">
              <terms></terms>
            </div>
            <div v-else>
              <multi-unit-data v-if="unitAddresses.length" v-bind:unitAddresses="unitAddresses" v-on:clear-unit-addresses="unitAddresses = []"></multi-unit-data>
              <house-data v-bind:houseData="houseData" ref="houseDataContainer"></house-data>
            </div>
          </div>
        </div>
        <no-results v-else></no-results>
      </div>
    </div>
    <div v-else v-bind:style="backgroundImage" class="background-image">
        <div class="dark-overlay">
          <div class="container-fluid">
            <img src="../../../../static/HomAptRealtyLogo.svg" alt="logo" class="logo">
            <div class="row">
              <div class="col-sm">
                <div class="promotion-body">
                  <h2 class="overlay-text">Find Your House Today!</h2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 offset-sm-3">
                <div class="container-fluid">
                  <!--<div class="row">
                    <div class="col-4">
                      <p class="overlay-text find-a-home">Find a Home</p>
                    </div>
                    <div class="col-4">
                      <router-link to="list">
                        <p class="overlay-text">Sell My Home</p>
                      </router-link>
                    </div>
                    <div class="col-4">
                      <router-link to="rebates">
                        <p class="overlay-text">HomApt Reward Program</p>
                      </router-link>
                    </div>
                  </div>-->
                  <div class="form-group">
                    <div class="input-group">
                      <input v-on:keydown.enter="changeURL" v-model="searchString" v-on:input="triggerSuggestions()" type="text" class="form-control" placeholder="Enter a city, zip, or address">
                      <div class="input-group-append" v-on:click="changeURL">
                        <div class="input-group-text"><i class="fas fa-search"></i></div>
                      </div>
                    </div>
                  </div>
                  <house-suggestion-dropdown ref="suggestionDropdown" v-on:suggestionSearch="performSuggestionSearch"></house-suggestion-dropdown>
                  <div class="row" v-if="!getSecretAccessKey">
                    <div class="col">
                      <input type="checkbox" id="checkbox" v-model="agreeToTerms">
                      <router-link to="/terms">
                        <label for="checkbox" class="overlay-text terms-text">Agree to Terms of Service</label>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import router from '../../../router/index.js'
import PropertySearchStatic from './PropertySearchStatic.vue'
import Terms from './rightSide/Terms.vue'
import HouseData from './rightSide/HouseData.vue'
import { mapGetters, mapActions } from 'vuex'
import TheSearchBar from './searchBar/TheSearchBar.vue'
import TheMap from './leftSide/TheMap.vue'
import NoResults from './leftSide/NoResults.vue'
import HouseSuggestionDropdown from './searchBar/HouseSuggestionDropdown.vue'
import MultiUnitData from './rightSide/MultiUnitData.vue'

export default {
  metaInfo: {
    title: 'Home',
    meta: [
      { vmid: 'description', content: 'Learn about how to maintain, buy and sell houses.' }
    ]
  },
  components: {
    PropertySearchStatic,
    Terms,
    HouseData,
    TheSearchBar,
    TheMap,
    NoResults,
    HouseSuggestionDropdown,
    MultiUnitData
  },
  props: {
    navbarHeight: Number
  },
  data () {
    return {
      searched: false,
      searchString: '',
      houseData: [],
      agreeToTerms: true,
      noHouseData: false,
      unitAddresses: [],
      suggestion: null
    }
  },
  mounted () {
    if (this.$route.query.search) this.setSearched()
  },
  computed: {
    ...mapGetters([
      'getSecretAccessKey'
    ]),
    ...mapGetters('homeSearch', [
      'getPropertyType',
      'getBedNumber',
      'getBathNumber',
      'getListingStatus',
      'getListingOptions',
      'getListingEvents',
      'getMinSqft',
      'getMaxSqft',
      'getMinPrice',
      'getMaxPrice',
      'getStories',
      'getInsideFeatures',
      'getOutsideFeatures',
      'getHeatingCooling',
      'getParking',
      'getMaxHomeAge',
      'getMinHomeAge',
      'getGarage',
      'getLotView',
      'getCommunityAmenities',
      'getMinHOA',
      'getMaxHOA'
    ]),
    backgroundImage () {
      return 'background-image: url("https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xlarge/uploads/104-night-house.jpg")'
    }
  },
  methods: {
    ...mapActions([
      'unauthenticatedLogin'
    ]),
    loadMoreCards ({target: {scrollTop, clientHeight, scrollHeight}}) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.$refs.houseDataContainer.loadMoreResults()
      }
    },
    async setSearched () {
      this.searched = true
      await this.$nextTick()
      window.addEventListener('resize', this.setMapWrapperHeight)
      this.setMapWrapperHeight()
    },
    unsetSearched () {
      this.searched = false
    },
    setHouseData (houseData) {
      window.removeEventListener('resize', this.setMapWrapperHeight)
      if (houseData.length === 0) {
        this.noHouseData = true
      } else {
        this.noHouseData = false
      }
      this.houseData = houseData
    },
    async changeURL () {
      if (this.agreeToTerms === false) return
      if (!this.getSecretAccessKey) {
        await this.unauthenticatedLogin()
      }
      router.push({
        path: '/propertysearch',
        query: {
          search: this.searchString,
          suggestion: JSON.stringify(this.suggestion),
          propertyType: this.getPropertyType,
          baths: this.getBathNumber,
          beds: this.getBedNumber,
          listingstatus: this.getListingStatus,
          listingoptions: this.getListingOptions,
          listingevents: this.getListingEvents,
          minsqft: this.getMinSqft,
          maxsqft: this.getMaxSqft,
          minprice: this.getMinPrice,
          maxprice: this.getMaxPrice,
          stories: this.getStories,
          insidefeatures: this.getInsideFeatures,
          outsidefeatures: this.getOutsideFeatures,
          hc: this.getHeatingCooling,
          parking: this.getParking,
          maxhomeage: this.getMaxHomeAge,
          minhomeage: this.getMinHomeAge,
          garage: this.getGarage,
          lotview: this.getLotView,
          communityamenities: this.getCommunityAmenities,
          minhoa: this.getMinHOA,
          maxhoa: this.getMaxHOA
        }
      }).catch((error) => {
        if (error.name !== 'NavigationDuplicated') {
          console.log(error)
        }
      })
    },
    setMapWrapperHeight (event) {
      var mapWrapper = document.getElementById('map-wrapper')
      var subnav = document.getElementById('subnav')
      if (mapWrapper) {
        mapWrapper.style.height = window.innerHeight - this.navbarHeight - subnav.offsetHeight + 'px'
      }
    },
    async triggerSuggestions () {
      this.$refs.suggestionDropdown.triggerSuggestions(this.searchString)
    },
    async performSuggestionSearch (suggestion) {
      this.suggestion = suggestion
      if ('unit_number' in suggestion) {
        let address = ''
        if ('street_name' in suggestion) { address += suggestion['street_name'] }
        if ('city' in suggestion) { address += ' ' + suggestion['city'] }
        this.searchString = address
      } else if ('zip_code' in suggestion) {
        this.searchString = suggestion.zip_code
      } else {
        this.searchString = suggestion.city
      }
      this.changeURL()
    }
  },
  watch: {
    '$route': function () {
      if (this.$route.query.search) this.setSearched()
      if (!this.$route.query.search) this.unsetSearched()
    },
    navbarHeight: function () {
      this.setMapWrapperHeight()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setMapWrapperHeight)
  }
}
</script>

<style scoped>
.background-image {
  height: 86vh;
  background-size: cover;
  background-position: center center !important;
}

.bottom-margin {
  margin-bottom: 6rem;
}

.fa-search {
  cursor: pointer;
}

.container-fluid {
  height: 100%;
}

.find-a-home {
  text-decoration: underline;
}

.logo {
  margin-left: 0.5rem;
  margin-top: 0.5rem;
  position: absolute;
  width: 100px;
}

.promotion-body {
  margin-bottom: 6rem;
  margin-top: 6rem;
  text-align: center;
}

.terms-text {
  text-decoration: underline;
  cursor: pointer;
}

.total-wrapper {
  min-height: 100% !important;
}

#map-wrapper {
  position: fixed;
}

#right-side {
  height: 100%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/PropertySearchBasePage.vue